export function rolesError(state, payload){
    state.error = true
    state.errorMessage = payload
    state.roles = ''
    
}
export function setRoles(state, payload){
    state.roles = payload.data.roles
    state.error= false
    state.errorMessage = ''
}
/**
 * metodo llamado desde la vista
 * @param {*} state 
 * @param {*} payload 
 */
export function setRol(state,payload){
    state.rol = payload
    state.error = false
    state.errorMessage = ''
}
export function flushRol(state){
    state.roles = []
    state.error= false
    state.errorMessage = ''
}